package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable
import kotlinx.serialization.Serializable

@Stable
@Serializable
sealed interface ThemeOption {
    @Serializable
    data object SYSTEM: ThemeOption
    @Serializable
    data object LIGHT : ThemeOption
    @Serializable
    data object DARK : ThemeOption
}

